<template>
  <div>
    <bread :list="list"></bread>
    <!--筛选 添加  -->
    <div class="flex align-center text-14 justify-start screenAdd">
        <el-form :label-position="labelPosition"  :model="formLabelAlign" class="demo-form-inline"  :inline="true">
            <el-form-item>
                <el-input v-model="formLabelAlign.ent_name"   placeholder="请输入" @keyup.enter.native="titleChoose">
                    <el-button slot="append" icon="el-icon-search" @click="titleChoose"></el-button>
                </el-input>
            </el-form-item>
           <el-form-item>
                    <el-button class="btn1" type="primary" @click="onSubmit">添加</el-button>
            </el-form-item>
        </el-form>
    </div>
    <!-- 数据列表  -->
    <list :dataList='dataList' @chidEditFun="parentEditFun" @chidDelFun="parDelFun" @handleChangeFun='handleChange'></list>
    <img  v-if="nolist" class="nolist" :src="$no" alt="">
    <!-- 分页  -->
    <page @CurrentChangeFun='getCurrent' :pageMsg="pageMsg"></page>
    <!-- 弹框  -->
    <masks   :masksData="masksData" @childCloseClick="parCloseFun" @childSureClick='submitEdit'></masks>
  
</div>
</template>
<script>
import bread from "../../../components/bread";
import page from "../../../components/page";
import masks from "../../../components/mask";
import list from "../components/list";  
export default {
    components: {
        bread,
        page,
        masks,
        list   //列表
    },
    data() {
        return {
            dataList:{
                isSkill:true,
                list:[]
            },
            nolist:false,
            labelPosition:'right',
            formLabelAlign:{
                token:window.localStorage.getItem('pc_token'),
                limit:10,   //每页查询条数 默认是10条
                page:1,  //当前页数
                ent_name:'',   //企业名称搜索
            },
            pageMsg:{},  //分页信息
            masksData:{    //弹框信息
                show:false,
                title:'设置机构',
                info:[
                    {title:'公司名称',name:'enterprise_title',value:'',palctHolder:'请输入',isText:true,isDisabled:true},
                    {title:'等级',name:'position',value:'',palctHolder:'请输入',isText:true,isDisabled:false,remind:'请输入等级'},
                    {title:'排序：',name:'sort',value:'',palctHolder:'请输入',isSort:true,tips:'数值越大越靠前',isDisabled:false,remind:'请选择排序'},
                    {name:'token',value:window.localStorage.getItem('pc_token'),hide:true,isDisabled:false},
                    {name:'id',value:'',hide:true,isDisabled:false},
                    {name:'type',value:'1',hide:true,isDisabled:true},
                ],
                cancelText:'取消',
                sureText:'确定选择'
            },
            isDisabled:true,
            list: [
                {title: "信息管理"},
                {title: "下级代理"},
            ],
        };
    },
    created(){
        this.lowerOrganlist(this.formLabelAlign);  // 我的下级机构列表
    },
    methods: {
        // 我的下级机构列表
        lowerOrganlist(params){
            this.post(this, "/home/lowerOrganlist",params).then(res => {
                var data=res.data.data;
                this.dataList.list=data.data;
                if(this.dataList.list.length==0){
                    this.nolist=true;
                }
                this.pageMsg=data;
            });
        },
        // 搜索回车
        titleChoose(){
            this.formLabelAlign.page=1;
            this.lowerOrganlist(this.formLabelAlign);
        },
        // 编辑机构信息
        parentEditFun(id){
            if (this.isDisabled&&document.getElementsByClassName('el-message').length === 0) {
                this.isDisabled=false;
                var data={
                    token:window.localStorage.getItem('pc_token'),
                    id,
                    type:1
                }
                this.post(this, "/home/editOrgan", data).then(res => {
                    var data=res.data.data;
                    this.masksData.info[0].value=data.enterprise_title;
                    this.masksData.info[1].value=data.position_name;
                    this.masksData.info[2].value=data.sort;
                    this.masksData.info[4].value=data.id;
                    this.masksData.show = true; 
                    this.isDisabled=true;
                });
            }
        },
        // 提交编辑机构信息
        submitEdit(data){
            var params={};
            if (this.isDisabled&&document.getElementsByClassName('el-message').length === 0) {
                this.isDisabled=false;
                for (var item of data){
                    if(!item.isDisabled){
                        if(item.value!==0){
                            if(!item.value||item.value.toString().trim() ==''){
                                this.$message.error(item.remind);
                                this.isDisabled=true;
                                return false;
                            }
                        }
                        params[item.name]=item.value;
                    }
                }
                this.post(this, "/home/submitEditorgan", params).then(res => {
                    if(res.data.code == 0) {
                        this.$message.success(res.data.msg);
                        this.masksData.show = false;
                        this.formLabelAlign.page=1; //刷新
                        this.lowerOrganlist(this.formLabelAlign);
                    } 
                    this.isDisabled=true;
                })
            }
        },
        // 修改排序
        handleChange(item){
            if (this.timer) {
                clearTimeout(this.timer);
            }
            var params={
                token:window.localStorage.getItem('pc_token'),
                id:item.id,
                position:item.position_name,
                sort:item.sort
            }
            if (item) {
                this.timer = setTimeout(() => {
                this.post(this, "/home/submitEditorgan", params).then(res => {
                    if(res.data.code == 0) {
                        this.$message.success(res.data.msg);
                        this.masksData.show = false;
                        this.formLabelAlign.page=1; //刷新
                        this.lowerOrganlist(this.formLabelAlign);
                    } 
                })
                    
                }, 300);
            } else {
                // 输入框中的内容被删为空时触发，此时会清除之前展示的搜索结果
                this.post(this, "/home/submitEditorgan", params).then(res => {
                    if(res.data.code == 0) {
                        this.masksData.show = false;
                        this.formLabelAlign.page=1; //刷新
                        this.lowerOrganlist(this.formLabelAlign);
                    } 
                })
            }
        },
        // 删除审核机构信息
        parDelFun(id){
            var data={
                token:window.localStorage.getItem('pc_token'),
                id
            }
            if (this.isDisabled&&document.getElementsByClassName('el-message').length === 0) {
                this.isDisabled=false;
                this.$confirm('确认是否删除？').then(_ => {
                    this.post(this, "/home/delectOrgan",data).then(res => {
                    // this.post(this, "/home/organReview",data).then(res => {
                        if(res.data.code == 0) {
                            this.$message.success(res.data.msg);
                            this.formLabelAlign.page=1; //刷新
                            this.lowerOrganlist(this.formLabelAlign);
                        }
                        this.isDisabled=true; 
                    })
                })
                .catch(_ => {
                    this.$message.success('已取消操作');
                    this.isDisabled=true; 
                });
            }
        },
        // 点击添加 跳转选择列表页面
        onSubmit(){
            this.$router.push({name: 'lowerLevelChoicse'})
        },
        // 获取当前页数
        getCurrent(val){
            this.formLabelAlign.page=val;
            this.lowerOrganlist(this.formLabelAlign);
        },
        parCloseFun(msg){  //弹框取消 关闭
            this.masksData.show = !msg;
        }
    },
};
</script>
<style scoped>
.line1{
    overflow: hidden;
    text-overflow: ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:1;
}
.line2{
    overflow: hidden;
    text-overflow: ellipsis;
    display:-webkit-box;
    -webkit-box-orient:vertical;
    -webkit-line-clamp:2;
}
.screenAdd{
    margin-top:50px;
}
.btn1{
    width: 130px;
    border: none;
    background-color: #FF7C00;
    color: #fff;
    margin-right: 30px;
}

input[type='number']{
    display:block;
    width:145px;
    border: 1px solid #cccccc;
    text-align:center
}
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
    background:red
}

</style>
<style >
.el-button--default .el-button--small ,.el-button--primary {
    width:56px;
    border: none;
}
.el-button--primary{
    background-color: #FF7C00 !important;
    color: #fff;
}
.el-button--default .el-button--small{
    background-color: #D2D2D2;
    color: #fff;
}
.el-message-box .el-button:nth-child(1):focus,.el-message-box .el-button:nth-child(1):hover{
    color: #FF7C00 !important;
    border-color: #FF7C00 !important;
    background-color: #fff !important;
}
</style>